import { onDomReady, onPageLeave } from './events';
import debounce from 'debounce';

/**
 * This module arranges for the scrolled position of a page
 * to be remembered between page visits. The scrolled position
 * is returned-to on subsequent visit of a particular page, unless
 * there is a hash tag on the URL, in which case that takes
 * precendence. We don't bother remembering this for all pages;
 * only certain pages.
 */

// Should it always happen? Or only when there's a flash message (typical
// after form submission).
const always = 1;
const whenFlashed = 2;

const rememberScrollPositionMap = {
  ['/']: always,
  ['/admin']: always,
  ['/admin/server']: always,
  ['/admin/users']: always,
  ['/admin/jobs']: always,
};

function shouldLoadScrollPosition(path) {
  switch (rememberScrollPositionMap[path]) {
  case always:
      return true;
  case whenFlashed:
      return document.getElementById('flash') !== null;
  default:
      return false;
  }
}

function shouldSaveScrollPosition(path) {
  return rememberScrollPositionMap[path];
}

function makeStorageKey(pathname) {
  return `${pathname}:scrollPosition`;
}

const oneOffKey = 'scrollPosition';

function rememberScrollPosition(pathname, scrollMeter) {
  const scrollPosition = scrollMeter.scrollTop;
  window.sessionStorage.setItem(makeStorageKey(pathname), scrollPosition);
}

export function rememberScrollPositionOnce() {
  const scrollMeter = document.getElementById('scroll-meter');
  if (!scrollMeter) {
    return;
  }
  const scrollPosition = scrollMeter.scrollTop;
  window.sessionStorage.setItem(oneOffKey, scrollPosition);
}

onDomReady(() => {
  const { pathname } = window.location;

  const scrollMeter = document.getElementById('scroll-meter');
  if (!scrollMeter) {
    return;
  }

  const oncePosition = window.sessionStorage.getItem(oneOffKey);
  if (oncePosition) {
    if (!window.location.hash) {
      scrollMeter.scrollTo(0, oncePosition);
    }
    window.sessionStorage.removeItem(oneOffKey);
  } else if (shouldLoadScrollPosition(pathname)) {
    const rememberedScrollPosition = window.sessionStorage.getItem(makeStorageKey(pathname));
    if (rememberedScrollPosition && !window.location.hash) {
      scrollMeter.scrollTo(0, rememberedScrollPosition);
    }
  }

  if (shouldSaveScrollPosition(pathname)) {
    scrollMeter.addEventListener(
      'scroll',
      debounce(() => rememberScrollPosition(pathname, scrollMeter), 100),
    );
  }
});
